// extracted by mini-css-extract-plugin
export default {"Section":"Dashboard_Section__2KbOT","SectionTitle":"Dashboard_SectionTitle__hLvoE","SectionLabel":"Dashboard_SectionLabel__8olUi","SectionContent":"Dashboard_SectionContent__LFC-d"};